function parseDateValue(value) {
  if (!value) return null;
  if (value instanceof Date) return Number.isNaN(value.getTime()) ? null : value;
  if (typeof value?.toDate === "function") {
    const d = value.toDate();
    return Number.isNaN(d.getTime()) ? null : d;
  }
  const d = new Date(value);
  return Number.isNaN(d.getTime()) ? null : d;
}

function stripHtml(rawHtml) {
  return String(rawHtml || "")
    .replace(/<[^>]*>/g, " ")
    .replace(/&nbsp;/gi, " ")
    .replace(/\s+/g, " ")
    .trim();
}

function ensureHtml(content) {
  const raw = String(content || "").trim();
  if (!raw) return "";
  const looksLikeHtml = /<\/?[a-z][\s\S]*>/i.test(raw);
  if (looksLikeHtml) return raw;
  const escaped = raw.replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;");
  return `<p>${escaped}</p>`;
}

function getLatestConferenceEntry(student) {
  const rows = Array.isArray(student?.conferences) ? student.conferences : [];
  let latest = null;

  for (let i = 0; i < rows.length; i += 1) {
    const row = rows[i] || {};
    const noteHtml = ensureHtml(row.note);
    if (!stripHtml(noteHtml)) continue;

    const byDate = parseDateValue(row.date);
    const byCreated = Number.isFinite(Number(row.createdAtMs)) ? new Date(Number(row.createdAtMs)) : null;
    const dateObj = byDate || byCreated;
    if (!dateObj) continue;

    const ms = dateObj.getTime();
    if (!latest || ms > latest.ms) {
      latest = {
        ms,
        dateObj,
        noteHtml,
      };
    }
  }

  return latest;
}

export function buildConferenceInfoForStudent(student, { activeDays = 14, now = new Date() } = {}) {
  const latest = getLatestConferenceEntry(student);
  if (!latest) return null;

  const thresholdMs = Number(activeDays) * 24 * 60 * 60 * 1000;
  const ageMs = now.getTime() - latest.ms;
  const isActive = ageMs >= 0 && ageMs <= thresholdMs;
  if (!isActive) return null;

  return {
    isActive: true,
    dateIso: latest.dateObj.toISOString(),
    dateLabel: latest.dateObj.toLocaleDateString(),
    noteHtml: latest.noteHtml,
  };
}

export function buildConferenceInfoMap(students = [], options = {}) {
  const map = {};
  for (let i = 0; i < (students || []).length; i += 1) {
    const student = students[i];
    if (!student?.id) continue;
    const info = buildConferenceInfoForStudent(student, options);
    if (info?.isActive) {
      map[student.id] = info;
    }
  }
  return map;
}
